<script>
        import * as animateScroll from "svelte-scrollto";
        import { onMount } from 'svelte';
        import Icon from 'fa-svelte';
        import { faSortUp } from '@fortawesome/free-solid-svg-icons/faSortUp';
        import { faSortDown } from '@fortawesome/free-solid-svg-icons/faSortDown';
        export let subSelection;

        let up1 = true;
        let up2 = true;
        let up3 = true;
        let up4 = true;
        let up5 = true;

        let handleClickArrow1 = () => {
            up1 = !up1;
            up2 = true;
            up3 = true;
            up4 = true;
            up5 = true;
        }
        let handleClickArrow2 = () => {
            up2 = !up2;
            up1 = false;
            up3 = true;
            up4 = true;
            up5 = true;
        }
        let handleClickArrow3 = () => {
            up3 = !up3;
            up1 = false;
            up2 = true;
            up4 = true;
            up5 = true;
        }
        let handleClickArrow4 = () => {
            up4 = !up4;
            up1 = false;
            up2 = true;
            up3 = true;
            up5 = true;
        }
        let handleClickArrow5 = () => {
            up5 = !up5;
            up1 = false;
            up2 = true;
            up3 = true;
            up4 = true;
        }

        onMount(async () => {
            if(subSelection == 0)  animateScroll.scrollToTop();
            else animateScroll.scrollTo({element: '#about-section-' + subSelection, offset: -80});
        });

</script>

<div class="row">

    <div class="col-12 white-bg" style="overflow:hidden;min-height: 100vh;">
        <img src="./img/background-A.svg" alt="" class="background-right disable-img" style="height: 100vh;">
        <div class="row">
            <img src="./img/download/carpeta.png" alt="" class="world05-base01-img disable-img">
            <div class="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-8 offset-0 offset-sm-1 offset-md-1 offset-lg-2 offset-xl-2 padding-fix">

                <h2 class="text-content title-content section-cvs" style="margin: 20px 0 0 0;"> DESCARGAS </h2>
                <hr class="underline-content">

                <div id="accordionReg" class="flex-arrow text-width-7">
                    <div class="card">
                        <div on:click={handleClickArrow1} class="card-header clickable" id="headingRegOne" style="padding:0;" data-toggle="collapse" data-target="#collapseRegOne" aria-expanded="true" aria-controls="collapseRegOne">
                            <h2 style="margin:0;padding:0;">
                              <button class="btn btn-link dropdown-header" >
                                    MATERIAL DE DIFUSIÓN
                              </button>
                              <div class="sort-arrow" >
                                  {#if up1 === true}<Icon class="arrow-top" icon={faSortUp}></Icon>{/if}
                                  {#if up1 === false}<Icon class="arrow-bot" icon={faSortDown}></Icon>{/if}
                              </div>
                            </h2>
                        </div>

                        <div id="collapseRegOne" class="collapse show" aria-labelledby="headingRegOne" data-parent="#accordionReg">
                          <div class="card-body">
                                <div class="group-links">
                                    <a href="./downloads/Folleto Certificación de Vivienda Sustentable (CVS).pdf" download>Folleto CVS</a>
                                    <a href="./downloads/Manual CVS 2020.pdf" download>Manual CVS 2020</a>
                                    <a href="./downloads/Manual CVS 2021.pdf" download>Manual CVS 2021</a>
                                    <a href="./downloads/Adenda Manual CVS 2021.pdf" download>Adenda Manual CVS 2021</a>
                                    <a href="./downloads/Manual de Uso de Marca Genérico.pdf">Manual de Uso de Marca Genérico</a>
                                    <a href="./downloads/Manual de Uso de Marca para Inmobiliarias.pdf">Manual de Uso de Marca para Inmobiliarias</a>
                                    <a href="./downloads/200511 Lista de Control CVS v.1.1.xlsx">Lista de Control para Cálculo de Puntaje</a>
                                </div>
                
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>

.world05-base01-img{
    right: 0;
    bottom: 0;
    height: 70%;
    position: absolute;
}

.white-bg{
    background-color: white;
    overflow: hidden;
}

.background-right{
    right: 0;
    position: absolute;
    height: 100%;
    /* max-height: 100vh; */
}

@media (max-width: 1400px){
    .card{
        height: auto;
    }
    .disable-img {
        display:none;
    }
    .padding-fix{
        padding:0 15px;
    }
}

.dropdown-header{
    font-size: 20pt;
    line-height: 21pt;
    text-align: justify;
    color: rgb(0, 99, 175);
    font-family: 'suga-pro';
    padding: 6px 12px 6px 12px;
    white-space: pre-wrap;
}

#accordionReg{
    margin: 5vh 0;
}

#accordionReg .card{
    margin: 2vh 0;
}

.background-right{
    right: 0;
    position: absolute;
    height: 100%;
    max-height: 100vh;
}

.text-width-7{
    width: 70%;
}

.padding-fix{
    padding:0 8px;
}

@media (max-width: 1400px){
    .card{
        height: auto;
    }
    .disable-img {
        display:none;
    }
    .text-width-7{
        width: 100%;
    }
    .padding-fix{
        padding:0 15px;
    }
}

.white-bg{
    background-color: white;
    overflow: hidden;
}

.card-header{
    background-color: rgb(241,245,234);
}

.sort-arrow {
    margin-left: auto;
}


.sort-arrow :global(.arrow-bot) {
    margin-bottom:13px;
    pointer-events: none;
}

.sort-arrow :global(.arrow-top) {
    margin-top:13px;
    pointer-events: none;
}

.flex-arrow .card-header h2{
    display: flex;
}

.group-links a{
    display: block;
    font-family: 'DINPro-Regular' !important;
    line-height: 25pt;
    color: #006937;
    font-size: 17pt;
}

</style>
